export *  from './msw-products.route';
export { productsTab as MswProductsTabRoute } from './msw-products.route';
export { registerProductTab as MswRegisterProductTabRoute } from './msw-products.route';
export { iptApproveOrReject as MswIPTapprove } from './msw-products.route';
export { ittApproveOrReject as MswITTapprove } from './msw-products.route';
export { getMaintainanceKeyTab as MSWGetMaintainanceKeyTabRoute } from './msw-products.route';
export { multiServiceActivationTab as MswMultiServiceActivationRoute } from './msw-products.route';

export *  from './products.store';
export { default as MswProductsStoreModule } from './products.store';
